<template>
  <div>
    <v-btn color="primary" dark class="mb-2 rbtn" to="/restaurants/create"
      >{{ $t("customers.restaurants.new") }}</v-btn
    >
    <DataTable
      :url="api.ACTIONS.PASSENGERS"
      :titles="titles"
      :fields-hidden-main="['deleted_at', 'updated_at', 'billing_email', 'address', 'phone_number']"
      :fields-hidden-add="['id', 'deleted_at', 'created_at', 'updated_at', 'address']"
      :input-types-add="{
        password: 'password',
        password_confirmation: 'password',
      }"
      :formatter="formatters"
      :title="$t('customers.restaurants.title')"
      :enableEdit="false"
      :add-rules="rules"
      :enableAdd="false"
      :initialUrlSearchParams="par"
      :actions-extra-main="actionsExtraMain"
    />
  </div>
</template>
<style>
.rbtn {
  float: right;
  z-index: 1;
  margin-top: 20px;
  margin-right: 20px;
  padding: 0px 45px;
}
</style>
<script>
import DataTable from "@/components/monaco/DataTable";
import moment from "moment";
import i18n from "@/i18n";

const required = (val) =>
  (val !== null && val !== undefined) || i18n.t("customers.restaurants.requiredField");
const email = (val) =>
  (!!val && val.search(/^(\w|-|\.|_)+@(\w|-|\.|_)+\.\w+$/) !== -1) ||
  i18n.t("customers.restaurants.validEmail");
const past = (val) =>
  (!!val && moment(val).format("YYYY-MM-DD") < moment().format("YYYY-MM-DD")) ||
  i18n.t("customers.restaurants.pastDate");

export default {
  name: "Restaurants",
  title() {
    return this.$t("customers.restaurants.title");
  },
  components: { DataTable },
  data() {
    return {
      accommodation: "restaurant",
      formatters: {
        created_at(value) {
          return moment(value).format(" DD MMM YYYY");
        },
      },
    };
  },
  computed: {
    rules() {
      return {
        username: [required],
        password: [required],
      };
    },
    par() {
      const par = new URLSearchParams();
      par.append("type", this.accommodation);
      return par;
    },

    titles() {
      return {
        id: this.$t("customers.restaurants.number"),
        // username: "Email",
        username: this.$t("customers.restaurants.userName"),
        full_name: this.$t("customers.restaurants.restaurantName"),
        phone: this.$t("customers.restaurants.phoneNumber"),
        created_at: this.$t("customers.restaurants.creationDate"),
      };
    },
    actionsExtraMain() {
      return {
        prices: {
          title: this.$t("customers.restaurants.profile"),
          icon: "edit",
          action: (item) =>
            this.$router.push({
              name: "PassengerProfile",
              params: { id: item.id },
            }),
        },
      };
    },
  },
};
</script>
